import { Button, Drawer, Form, Space, Input, Popover, message } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import { useSendEmailMutation } from "../../../store/endpoints/email/email";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../../utils/XLSXExport";
import UpdatePanel from "./UpdatePanel";

const { startCase } = require("lodash");

const { Search } = Input;

export default function CustomerPanel({
  setShowDetails,
  isVisible,
  customers,
  title,
  refetch,
}: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const [selected, setSelected] = useState<any>([]);
  const [updateModal, setUpdateModal] = useState(false);

  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();
  const [emailForm] = Form.useForm();

  const sendMail = async (values: any) => {
    const data = customers?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Name: record?.name,
        Account: record?.account ? record?.account : "-",
        Segment: record?.segment?.name ? record?.segment?.name : "-",
        Email: record?.email ? record?.email : "-",
        Telephone: record?.phone ? record?.phone : "-",
        Mobile: record?.mobile ? record?.mobile : "-",
        "Last Activity":
          record?.unused === 0
            ? "This Month"
            : `${record?.unused} Month(s) ago`,
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  useEffect(() => {
    if (emailResult.isSuccess) {
      message.success("Email Sent Successfully");
    }
  }, [emailResult]);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  return (
    <Drawer
      title={`${title} : ${customers?.length}`}
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by name"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex flex-row">
            <Popover
              content={
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    form={emailForm}
                    onFinish={sendMail}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: "Email is Required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        { required: true, message: "Subject is Required" },
                      ]}
                    >
                      <Input placeholder="Email Subject" />
                    </Form.Item>
                    <div className="flex flex-row justify-between">
                      <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                        <Button
                          onClick={() => {
                            toggleMessageModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </>
              }
              title="Message Content"
              trigger="focus"
              placement="left"
              visible={messageModal}
              // onVisibleChange={}
            >
              <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                <RiMailSendLine size={21} />
                <span
                  className="ml-2"
                  onClick={async () => {
                    toggleMessageModal(true);
                  }}
                >
                  Send Email
                </span>
              </button>
            </Popover>
            <button
              color="#E50000"
              className="flex ml-4 justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={async () => {
                  const data = customers?.map((record: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      Name: record?.name,
                      Account: record?.account ? record?.account : "-",
                      Segment: record?.segment?.name
                        ? record?.segment?.name
                        : "-",
                      Email: record?.email ? record?.email : "-",
                      Telephone: record?.phone ? record?.phone : "-",
                      Mobile: record?.mobile ? record?.mobile : "-",
                      "Last Activity":
                        record?.unused === 0
                          ? "This Month"
                          : `${record?.unused} Month(s) ago`,
                    };
                  });
                  ExportToExcel(data, "Customers.xlsx");
                }}
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex pt-1 pb-2 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-52 truncate font-bold">Customer</div>
              <div className="w-24 truncate font-bold">Segment</div>
              <div className="w-36 truncate text-center font-bold">Account</div>
              <div className="w-36 truncate font-bold">Mobile</div>
            </div>
            <div className="font-bold w-full">Action</div>
          </div>
        </div>
        {customers
          ?.filter((customer: any) => customer?.name?.includes(search))
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-52 truncate">
                    {item?.name === null
                      ? "-"
                      : startCase(item?.name?.toLowerCase())}
                  </div>

                  <div className="w-24 truncate">
                    {item?.segment?.name === null ? "-" : item?.segment?.name}
                  </div>
                  <div className="w-36 truncate text-center">
                    {item?.account === null ? "-" : item?.account}
                  </div>
                  <div className="w-36 truncate">
                    {item?.mobile === null ? "-" : item?.mobile}
                  </div>
                </div>
                <div className="w-full">
                  <button
                    onClick={() => {
                      setSelected({
                        ...item,
                      });
                      setUpdateModal(true);
                    }}
                    className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
                  >
                    <FiEdit /> <span className="ml-1">Edit</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>
      <UpdatePanel
        selected={selected}
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={refetch}
      />
    </Drawer>
  );
}
